module.exports = __webpack_public_path__ + "img/dhd.1f71a813.jpg";